<template>
    <div style="position: relative;" class="wow container-iframe">
        <video 
            v-if="isMP4Video" 
            controls 
            :id="videoId"
            class="video-frame"
            :poster="videoThumbnail"
        >
            <source :src="videoSource" type="video/mp4"/>
        </video>
        <iframe 
            v-else
            :src="videoSource"
            :id="videoId"
            frameborder="0"
            loading="lazy"
            allowfullscreen="true"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            class="video-frame"
        >
        </iframe>
    </div>
</template>

<script>
    import "../../../utils/cloudflarestream.sdk.latest";

    export default {
        name: "EmbeddedVideoPlayer",
        props: {
            videoId: String,
            videoSource: String,
            videoThumbnail: {
                type: String,
                default: null,
            },
            selectedVideoId: {
                type: String, 
                default: null,
            },
            isMP4Video: Boolean,
        },
        data() {
            return {
                player: null,
                mp4Player: null,
            };
        },
        watch: {
            selectedVideoId(newValue){
                if(this.isMP4Video) {
                    if(!this.mp4Player.paused && (newValue !== this.videoId)) {
                        this.mp4Player.pause();
                    }
                }
                else {
                    if(!this.player.paused && (this.player.currentTime > 0) && (newValue !== this.videoId)) {
                        this.player.pause();
                    }
                }
            },
        },
        mounted(){
            const videoElement = document.getElementById(this.videoId);

            if(this.isMP4Video) {
                // MP4 PLAYER IN IFRAME
                this.mp4Player = videoElement;

                // MP4 PLAYER LISTENING TO PLAY EVENT
                this.mp4Player.addEventListener('play', () => {
                    if(this.videoId !== this.selectedVideoId) {
                        this.$emit('video-player-in-progress', this.videoId);
                    }
                });
                // MP4 PLAYER LISTENING TO ENDED EVENT
                this.mp4Player.addEventListener('ended', () => {
                    if(this.videoId === this.selectedVideoId) {
                        this.$emit('video-player-in-progress', null);
                    }
                    this.mp4Player.currentTime = 0;
                });
            }
            else {
                // CLOUDFLARE STREAMING PLAYER IN IFRAME
                this.player = Stream(videoElement);

                // CLOUDFLARE STREAMING PLAYER LISTENING TO PLAY EVENT
                this.player.addEventListener('play', () => {
                    if(this.videoId !== this.selectedVideoId) {
                        this.$emit('video-player-in-progress', this.videoId);
                    }
                });
                // CLOUDFLARE STREAMING PLAYER LISTENING TO ENDED EVENT
                this.player.addEventListener('ended', () => {
                    if(this.videoId === this.selectedVideoId) {
                        this.$emit('video-player-in-progress', null);
                    }
                    this.player.currentTime = 0;
                });
            }
        },
        destroyed() {
            this.player = null;
            this.mp4Player = null;
        }
    }
</script>
<style scoped>
    .container-iframe {
        position: relative;
        overflow: hidden;
        width: 100%;
        padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    }
    .video-frame {
        border: 4px solid black; 
        position: absolute; 
        top: 0; 
        left: 0; 
        height: 100%; 
        width: 100%; 
        border-radius: 10px;
        object-fit: fill;
    }
</style>